export default __webpack_public_path__ + "static/media/logo.b391d62a.png";